import { BaseApiService } from "Apis/Service/BaseApiService";
import { ILoginController } from "Interfaces/Controllers/ILoginController";
import { IEnvConfigUtils } from "Interfaces/Utils/IEnvConfigUtils";
import { inject, injectable } from "inversify";
import { Login } from "Models/Authentication/Login";
import Types from "ServiceProvider/Types";
import request from "../BaseRequest";

@injectable()
export class LoginController extends BaseApiService implements ILoginController {
    constructor(@inject(Types.IEnvConfigUtils) envConfigUtils: IEnvConfigUtils) {
        super(envConfigUtils, "login");
    }

    public async getLoginAsync(token: string, companyId: number): Promise<Login> {
        this.init();
        const headers = { ...this.headers, Authorization: token, companyId };

        const response = await request
            .get(this.endpoint)
            .set(headers);

        return response.body as Login;
    }
}


// WEBPACK FOOTER //
// ./src/Apis/Controllers/LoginController.ts